import React from 'react';
import PropTypes from 'prop-types';

const ChevronLeft = ({ theme, fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 2.99999C16.8839 2.88358 16.746 2.79122 16.5941 2.7282C16.4422 2.66519 16.2794 2.63275 16.115 2.63275C15.9506 2.63275 15.7878 2.66519 15.6359 2.7282C15.4841 2.79122 15.3461 2.88358 15.23 2.99999L6.92001 11.3C6.73679 11.4869 6.63416 11.7382 6.63416 12C6.63416 12.2617 6.73679 12.5131 6.92001 12.7L15.23 21C15.3382 21.1439 15.4761 21.263 15.6342 21.3492C15.7924 21.4353 15.9671 21.4866 16.1468 21.4995C16.3264 21.5124 16.5067 21.4867 16.6755 21.424C16.8444 21.3613 16.9978 21.2632 17.1255 21.1362C17.2532 21.0092 17.3522 20.8564 17.4158 20.6879C17.4795 20.5194 17.5062 20.3392 17.4943 20.1595C17.4824 19.9798 17.4322 19.8048 17.3469 19.6462C17.2616 19.4875 17.1433 19.349 17 19.24L9.76001 12L17 4.73999C17.2261 4.50678 17.3525 4.19476 17.3525 3.86999C17.3525 3.54521 17.2261 3.23319 17 2.99999Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

ChevronLeft.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default ChevronLeft;
